import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = gql`
query SkillsDirectoriesForTransfer($channelId: ID) {
  requestTypeDirectoriesForTransfer {
    id
    name
    team {
      id
      name
    }
    commonOperatorsCounter(channelId: $channelId)
    priority
    requestTypes {
      priority
      activitiesCounter(channelId: $channelId)
      operatorsCounter(channelId: $channelId)
      requestType {
        active
        id
        name
        description
      }
    }
  }
}`;

export default function getSkillsDirectoriesForTransfer(channelId) {
  return apollo.client.query({
    query,
    variables: {
      channelId,
    },
    fetchPolicy: 'network-only',
  }).then((res) => res.data.requestTypeDirectoriesForTransfer);
}
